<template>
    <b-card
            border-variant="gray-400"
            class="property-details-actions"
            :class="{
            'd-none d-xl-block': !activeActionButtons.length
        }"
    >
        <b-row>
            <b-col
                    class="actions-container"
                    cols="12"
            >
                <div class="horizontal-action-align d-none d-lg-flex">
                    <property-details-favorite-action
                            :property-app-resource="propertyAppResource"
                            :favorite-status="isMyHome ? true :favoriteStatus"
                            :favorite-option-enabled="!isMyHome && favoriteOptionEnabled"
                            :property-details-route="propertyDetailsRoute"
                    />
                    <b-button
                            variant="secondary"
                            size="lg"
                            block
                            @click="handleFilesClick"
                    >
                        <i
                                v-if="!totalFilesAttached"
                                class="far fa-paperclip"
                        />
                        <div v-else>
                            <b-badge
                                    pill
                                    variant="danger"
                            >
                                {{ totalFilesAttached }}
                            </b-badge>
                        </div>
                        {{ !totalFilesAttached ? 'Attach' : 'Files' }}
                    </b-button>
                    <b-button
                            variant="secondary"
                            size="lg"
                            block
                            @click="handleDiscussionClick()"
                            :disabled="discussionIsLoading"
                    >
                        <i class="far fa-comments-alt" />
                        Discuss
                    </b-button>
                </div>

                <div
                    v-if="isPending"
                    class="pt-2 pt-sm-4 mt-2 border-top"
                >
                    <h1 class="pending-title text-center">
                        Sale Pending
                    </h1>
                    <p class="pending-description">
                        The seller has accepted an offer. This property is now pending or under contract.
                    </p>
                </div>

                <div
                    v-if="propertyAppResource.isSold"
                    :class="{
                        'border-top': !isMobile
                    }"
                >
                    <div class="your-home-title text-center mt-sm-4">
                        Is this your home?
                    </div>

                    <p class="your-home-description mt-sm-2">
                        Claim this property as your own to track its estimated value and use tools to help you manage it.
                    </p>

                    <b-button
                        class="action-btn-right option-tour mt-sm-4 mx-0 your-home-button"
                        variant="secondary"
                        size="lg"
                        block
                        @click="handleRequestButtonClick(PROPERTY_SEARCH_ACTIONS.IM_THE_OWNER)"
                    >
                        I'm the Owner
                    </b-button>
                </div>

                <div
                        class="scroll-area overflow-auto"
                        v-else-if="activeActionButtons.length"
                >
                    <div class="btn-actions-wrapper d-flex d-lg-block float-left">
                        <!-- Option not implemented yet & hidden in re-web until then -->
                        <b-button
                                v-if="activeActionButtons.includes('tour')"
                                class="action-btn-right option-tour"
                                variant="secondary"
                                size="lg"
                                block
                                @click="handleRequestButtonClick(PROPERTY_SEARCH_ACTIONS.TOUR)"
                        >
                            Tour
                        </b-button>
                        <b-button
                                v-if="activeActionButtons.includes('tour-requested')"
                                id="tour-requested-btn"
                                class="action-btn-right option-tour-requested"
                                variant="secondary"
                                size="lg"
                                block
                                @click="handleRequestButtonClick(PROPERTY_SEARCH_ACTIONS.TOUR)"
                        >
                            <i class="far fa-check mr-2 text-gray-600" />
                            Tour Requested
                        </b-button>
                        <!-- Option not implemented yet & hidden in re-web until then -->
                        <b-button
                                v-if="activeActionButtons.includes('offer') "
                                class="action-btn-right option-offer"
                                variant="secondary"
                                size="lg"
                                block
                                @click="handleRequestButtonClick(PROPERTY_SEARCH_ACTIONS.OFFER)"
                        >
                            Offer
                        </b-button>
                        <!-- Option not implemented yet & hidden in re-web until then -->
                        <b-button
                                v-if="activeActionButtons.includes('finance') "
                                class="action-btn-right option-finance"
                                variant="secondary"
                                size="lg"
                                block
                                @click="handleRequestButtonClick(PROPERTY_SEARCH_ACTIONS.FINANCE)"
                        >
                            Finance
                        </b-button>
                        <!-- Option not implemented yet & hidden in re-web until then -->
                        <b-button
                                v-if="activeActionButtons.includes('trade') "
                                class="action-btn-right option-trade-in"
                                variant="secondary"
                                size="lg"
                                block
                                @click="handleRequestButtonClick(PROPERTY_SEARCH_ACTIONS.TRADE)"
                        >
                            Trade-In
                        </b-button>
                    </div>
                </div>

                <template v-if="showRealEstateContactSection && !propertyAppResource.isSold">
                    <hr class="mt-0">
                    <property-details-contact-real-estate-agent
                            v-if="workspaceMembersInitialized"
                            :real-estate-agent="getRealEstateAgent"
                            :workspace-uuid="workspaceUuid"
                            :is-real-estate-type-excluded-in-organization="isRealEstateTypeExcludedInOrganization"
                            :home-ownership-buy-home-modal="homeOwnershipBuyHomeModal"
                            :property-app-resource="propertyAppResource"
                    />
                </template>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
    import './PropertyDetailsActions.scss';
    import './PropertyDetailsActions.downlg.scss';
    import AppResource from "@milestoneslabs/milestones-js-engine/src/Data/AppResource";
    import {events} from "../../../../index";
    import GetPropertyInstanceMixin from "../../../mixins/GetPropertyInstanceMixin";
    import AppResourceSearch from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch";
    import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
    import {store} from "../../../../index";
    import PropertyDetailsFavoriteAction from "./PropertyDetailsFavoriteAction/PropertyDetailsFavoriteAction";
    import {GLOBAL_EVENTS} from "../../../../helpers/globalEvents";
    import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
    import {PROPERTY_SEARCH_DISABLED_OPTION} from "../../../mixins/PropertySearchMixin";
    import {PROPERTY_SEARCH_ACTIONS} from "../../../../helpers/variables";
    import {mapGetters} from "vuex";
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import FavoriteButtonMixin from "../../../mixins/FavoriteButtonMixin";
    export {PROPERTY_DETAILS_FAVORITE_ACTION} from "./PropertyDetailsFavoriteAction/PropertyDetailsFavoriteAction";
    export const ADD_FILE_MODAL_OPEN = 'ADD_FILE_MODAL_OPEN';

    export default {
        name: "PropertyDetailsActions",
        components: {
            PropertyDetailsFavoriteAction,
            // eslint-disable-next-line max-len
            PropertyDetailsContactRealEstateAgent: () => import('./PropertyDetailsContactRealEstateAgent/PropertyDetailsContactRealEstateAgent'),
        },
        mixins: [
            GetPropertyInstanceMixin,
            ShowNotificationMixin,
            IsMobileMixin,
            FavoriteButtonMixin,
        ],
        props: {
            propertyAppResource: {
                type: AppResource,
                required: true,
            },
            favoriteStatus: {
                type: Boolean,
                default: false
            },
            propertyDetailsRoute: {
                type: [String, Object],
                default: 'property.details.view',
            },
            favoriteOptionEnabled: {
                type: Boolean,
                default: true
            },
            activeActionButtons: {
                type: Array,
                default: () => []
            },
            isPending: {
                type: Boolean,
                default: false
            },
            showRealEstateContactSection: {
                type: Boolean,
                default: false,
            },
            workspaceMembersInitialized: {
                type: Boolean,
                default: false,
            },
            getRealEstateAgent: {
                type: Object,
                required: false,
            },
            isRealEstateTypeExcludedInOrganization: {
                type: Boolean,
                required: true,
            },
            homeOwnershipBuyHomeModal: {
                type: String,
                required: false,
            },
        },

        data() {
            return {
                totalFilesAttached: 0,
                discussionIsLoading: false,
                PROPERTY_SEARCH_ACTIONS,
                addFileModalId: 'attachPropertyFileModalId',
            };
        },

        computed: {
            ...mapGetters({
                coreProperty: 'getCoreProperty',
            }),
            isMyHome() {
                if (!this.coreProperty) {
                    return false;
                }
                return this.propertyAppResource.uuid === this.coreProperty.parentPropertyUuid;
            },
            workspaceUuid() {
                return store.getters.getWorkspaceUuid;
            }
        },

        beforeMount() {
            this.listeners('$on');
            this.fetchPropertyFiles();
        },

        beforeDestroy() {
            this.listeners('$off');
        },

        methods: {
            listeners(method) {
                this.$bus[method](events.PROPERTY_FILES_ADDED_EVENT, this.handleFileUploadEvent);
                this.$bus[method](events.PROPERTY_FILE_ADDED_THROUGH_CHAT, this.handlePropertyFileAddedThroughChat);
                this.$bus[method](GLOBAL_EVENTS.PROPERTY_DETAILS.DISCUSSION_CLICK, this.handleDiscussionClick);
                this.$bus[method](GLOBAL_EVENTS.PROPERTY_DETAILS.FILES_CLICK, this.handleFilesClick);
            },

            handleRequestButtonClick(type) {
                this.$bus.$emit(PROPERTY_SEARCH_DISABLED_OPTION, type, {
                    propertyUuid: this.propertyAppResource.uuid,
                    address: this.propertyAppResource.addresses.getFirst(),
                });
            },

            async handleDiscussionClick(instance = null) {
                if (!this.favoriteOptionEnabled) {
                    this.$bus.$emit(
                        PROPERTY_SEARCH_DISABLED_OPTION,
                        PROPERTY_SEARCH_ACTIONS.CHAT,
                        {propertyUuid: this.propertyAppResource.uuid}
                    );
                } else {
                    this.discussionIsLoading = true;

                    try {
                        if (!instance) {
                            instance = await this.favoriteProperty();
                        }

                        const propertyInstanceUuid = (instance || {}).uuid;
                        if (!!propertyInstanceUuid) {
                            this.$bus.$emit(events.CREATE_PROPERTY_CHANNEL_EVENT, {
                                propertyInstanceUuid: propertyInstanceUuid
                            });
                            this.$bus.$emit(events.OPEN_CHAT_WINDOW);
                        }
                    } catch (e) {
                        console.error(e);
                        this.showNotification({
                            type: 'error',
                            message: 'There was an error while creating chat channel for property. Try again later.'
                        });
                    } finally {
                        this.discussionIsLoading = false;
                    }
                }
            },

            async handleFilesClick() {
                if (!this.favoriteOptionEnabled) {
                    this.$bus.$emit(
                        PROPERTY_SEARCH_DISABLED_OPTION,
                        PROPERTY_SEARCH_ACTIONS.ATTACH_FILES,
                        {propertyUuid: this.propertyAppResource.uuid}
                    );
                } else {
                    let instance;
                    try {
                        instance = await this.favoriteProperty();
                    } catch (e) {
                        console.error(e);
                        this.showNotification({
                            type: 'error',
                            message: 'There was an error while attaching property. Try again later.'
                        });
                        return;
                    }

                    this.handleDiscussionClick(instance);
                    this.$bus.$emit(ADD_FILE_MODAL_OPEN, {
                        modalId: this.addFileModalId
                    });
                }
            },

            async fetchPropertyFiles() {
                let totalFilesAttached = 0;
                if (this.propertyAppResource.uuid && this.workspaceUuid) {
                    let fileAppResourceSearch = new AppResourceSearch('File');
                    let fileApiFilter = new ApiFilter({
                        andOr: "and",
                        relations: {
                            propertyInstances: new ApiFilter({
                                params: {
                                    propertyUuid: this.propertyAppResource.uuid,
                                    workspaceUuid: this.workspaceUuid,
                                },
                            }),
                        }
                    });

                    fileAppResourceSearch.setSearchData({
                        page: 1,
                        pageSize: 1,
                        filter: fileApiFilter,
                    });

                    await fileAppResourceSearch.load();
                    totalFilesAttached = (fileAppResourceSearch || {}).total || 0;
                }
                this.totalFilesAttached = totalFilesAttached;
            },

            handleFileUploadEvent() {
                this.fetchPropertyFiles();
            },

            handlePropertyFileAddedThroughChat({propertyUuid}) {
                if (propertyUuid === this.propertyAppResource.uuid) {
                    this.handleFileUploadEvent();
                }
            }
        },
    };
</script>
